const SCALE = 15 / 9
const OFFSET = 45

export function fovToSocketUnits(fov: number): number {
  return (fov - OFFSET) / SCALE + OFFSET
}

export function socketUnitsToFov(amount: number | null): number {
  return amount === null ? 0 : (amount - OFFSET) * SCALE + OFFSET
}
